import React, { useEffect, useRef } from "react";
import { motion, useAnimation, useInView } from "framer-motion";

export default function Dart({ dimension = "150" }) {
  const controls = useAnimation();
  const iconRef = useRef(null);
  const isInView = useInView(iconRef, { once: true });
  useEffect(() => {
    if (isInView) {
      controls.start("visible");
    }
  }, [isInView]);

  const iconPath = {
    hidden: {
      pathLength: 0,
      stroke: "var(--secondary)",
    },
    visible: {
      pathLength: 1,
      stroke: [
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--secondary)",
        "var(--primary)",
      ],
      transition: {
        duration: 2,
        ease: "easeInOut",
      },
    },
  };
  return (
    <motion.svg
      width={dimension}
      height={dimension}
      viewBox="0 0 500 500"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      ref={iconRef}
      initial="hidden"
      animate={controls}
    >
      <motion.path
        variants={iconPath}
        d="M250 250L343.75 156.25"
        strokeWidth="20"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <motion.path
        variants={iconPath}
        d="M468.75 93.75H406.25V31.25L343.75 93.75V156.25H406.25L468.75 93.75Z"
        strokeWidth="20"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <motion.path
        variants={iconPath}
        d="M250 343.75C301.777 343.75 343.75 301.777 343.75 250C343.75 198.223 301.777 156.25 250 156.25C198.223 156.25 156.25 198.223 156.25 250C156.25 301.777 198.223 343.75 250 343.75Z"
        strokeWidth="20"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <motion.path
        variants={iconPath}
        d="M421.875 140.625C442.187 171.875 453.125 209.375 453.125 250C453.125 362.5 362.5 453.125 250 453.125C137.5 453.125 46.875 362.5 46.875 250C46.875 137.5 137.5 46.875 250 46.875C290.625 46.875 328.125 57.8125 359.375 78.125"
        strokeWidth="20"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </motion.svg>
  );
}
